import {getComponentName, getBaseName} from '../js/main/utils';
import createStack from './directives/stack';

function install(Vue) {
  function loadComponents() {
    // eslint-disable-next-line no-undef
    const requireComponent = require.context(
      './components',
      true, // recursive search
      // The regular expression used to match base component filenames
      /Slo[A-Z]\w+\.vue$/
    );

    requireComponent.keys().forEach(fileName => {
      const componentConfig = requireComponent(fileName);
      const componentName = getComponentName(fileName);

      Vue.component(
        componentName,
        // Look for the component options on `.default`, which will
        // exist if the component was exported with `export default`,
        // otherwise fall back to module's root.
        componentConfig.default || componentConfig
      );
    });
  }

  function loadFilters() {
    // eslint-disable-next-line no-undef
    const requireFilter = require.context(
      './filters',
      true, // recursive search
      /.*\.js$/
    );

    requireFilter.keys().forEach(fileName => {
      const filterConfig = requireFilter(fileName);
      const filterName = getBaseName(fileName);

      Vue.filter(filterName, filterConfig.default || filterConfig);
    });
  }

  function loadDirectives() {
    Vue.directive('stack-x', createStack('x'));
    Vue.directive('stack-y', createStack('y'));
  }

  Object.defineProperty(Vue.prototype, '$modal', {
    get() {
      return {
        show: params => this.$root.$emit('slo-modal:show', params),
        hide: () => this.$root.$emit('slo-modal:hide')
      };
    }
  });

  loadFilters();
  loadDirectives();
  loadComponents();
}

export default {install};
